var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "#EB1F60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5357 1.16748H9.05357L8.7808 0.655585C8.72302 0.546147 8.63402 0.45409 8.5238 0.389771C8.41358 0.325451 8.28652 0.291421 8.15692 0.291509H4.84018C4.71087 0.29104 4.58403 0.324943 4.47421 0.389334C4.36438 0.453725 4.276 0.545999 4.2192 0.655585L3.94643 1.16748H0.464286C0.341149 1.16748 0.223057 1.21363 0.135986 1.29576C0.0489157 1.3779 0 1.48931 0 1.60547L0 2.48144C0 2.5976 0.0489157 2.70901 0.135986 2.79114C0.223057 2.87328 0.341149 2.91943 0.464286 2.91943H12.5357C12.6588 2.91943 12.7769 2.87328 12.864 2.79114C12.9511 2.70901 13 2.5976 13 2.48144V1.60547C13 1.48931 12.9511 1.3779 12.864 1.29576C12.7769 1.21363 12.6588 1.16748 12.5357 1.16748ZM1.54375 13.0752C1.56589 13.4088 1.72197 13.7219 1.98019 13.9508C2.23842 14.1796 2.5794 14.307 2.93371 14.3071H10.0663C10.4206 14.307 10.7616 14.1796 11.0198 13.9508C11.278 13.7219 11.4341 13.4088 11.4562 13.0752L12.0714 3.7954H0.928571L1.54375 13.0752Z",
    fill: "#EB1F60"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.35547f09118e7e49d921ff1d56531d2a.svg";
export { ForwardRef as ReactComponent };